import axios from "axios";
import env from "../env";
import { AuthBody, StudentDetails } from "src/Interfaces/auth";

const api_url = env.API_URL;

export const login = async (body: AuthBody) => {
    try {
        const response = await axios.post(api_url + `auth/login`, body);
        return response;
    } catch (error) {
        throw error;
    }
}

export const adminLogin = async (body: any) => {
    try {
        const response = await axios.post(api_url + `auth/admin/login`, body);
        return response;
    } catch (error) {
        throw error;
    }
}

export const register = async (body: StudentDetails) => {
    try {
        const response = await axios.post(api_url + `auth/register`, body);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getStreams = async () => {
    try {
        const response = await axios.get(api_url + `auth`);
        return response;
    } catch (error) {        
        throw error;        
    }
}

export const initial = async (token:any) => {
    try {
        const response = await axios.get(api_url + `auth/me`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {        
        throw error;        
    }
}

export const getSpg = async (userId: string, token: any) => {
    try {
        const response = await axios.get(api_url + `auth/sgp-performance?userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {        
        throw error;        
    }
}

export const tokenCheck = async (token: any) => {
    try {
        const response = await axios.get(api_url + `auth/token-check`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
}